// it is a dirty code

import useAppConfig from 'canvas_states/config/useAppConfig';

// TODO remove the dirty code with https://plusgrade.jira.com/browse/FE-2428
const useIsLA = () => {
  const { config } = useAppConfig().states;

  return {
    states: {
      isLA: config.companyCode === 'LA',
    },
  };
};

export default useIsLA;
